import {
  PictureAsPdfOutlined,
  DescriptionOutlined,
  SlideshowOutlined,
  TableChartOutlined,
} from "@mui/icons-material";

export default function FileTypeIcon({ url, sx }) {
  if (!url) return null;
  const lower = url.toLowerCase().split("?")[0];

  let Icon, color;
  if (lower.endsWith(".pdf")) {
    Icon = PictureAsPdfOutlined;
    color = "#d32f2f";
  } else if (lower.endsWith(".doc") || lower.endsWith(".docx")) {
    Icon = DescriptionOutlined;
    color = "#1565c0";
  } else if (lower.endsWith(".ppt") || lower.endsWith(".pptx")) {
    Icon = SlideshowOutlined;
    color = "#e65100";
  } else if (lower.endsWith(".xls") || lower.endsWith(".xlsx")) {
    Icon = TableChartOutlined;
    color = "#2e7d32";
  } else {
    return null;
  }

  return <Icon sx={{ fontSize: "1.4rem", color, flexShrink: 0, ...sx }} />;
}
